let PlayersSwapped = {
    SWAPPED_PLAYERS_SET_LAST_UPDATED_LINEUP_ID: 'SWAPPED_PLAYERS_SET_LAST_UPDATED_LINEUP_ID',
};

export default PlayersSwapped;
